export const categories = [{
        id: 1,
        title: "General knowledge",
        difficulty: "easy",
        categoryNumber: 9,
    },
    {
        id: 2,
        title: "Film",
        difficulty: "easy",
        categoryNumber: 11,
    },
    {
        id: 3,
        title: "Video games",
        difficulty: "easy",
        categoryNumber: 15,
    },
    {
        id: 4,
        title: "History",
        difficulty: "medium",
        categoryNumber: 23,
    },
    {
        id: 5,
        title: "Telivision",
        difficulty: "medium",
        categoryNumber: 14,
    },
    {
        id: 6,
        title: "Science & Nature",
        difficulty: "medium",
        categoryNumber: 17,
    },
    {
        id: 7,
        title: "Computers",
        difficulty: "easy",
        categoryNumber: 18,
    },
    {
        id: 8,
        title: "Music",
        difficulty: "medium",
        categoryNumber: 12,
    },
    {
        id: 9,
        title: "Geography",
        difficulty: "medium",
        categoryNumber: 22,
    }
]